var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered my-2"},[_c('p',{staticClass:"has-text-grey is-size-7"},[_vm._v("※ QRコードは株式会社デンソーウェブの登録商標です。")])])
}]

export { render, staticRenderFns }